import classNames from 'classnames';

export function cn(...inputs: (string | Record<string, boolean> | undefined | null)[]) {
  return classNames(...inputs);
}
